<template>
  <div>
    <v-card flat>
      <v-form v-model="valid" ref="PostcodeCheckForm" @submit.prevent>
        <v-card-text class="mt-n2 pt-1">{{ descriptionText }}</v-card-text>
        <v-divider class="mb-2"></v-divider>
        <v-text-field
          v-model="postcode"
          outlined
          prepend-inner-icon="home"
          :rules="[required('PostCode'), isPostCode]"
          label="PostCode"
          class="pa-2 pb-0 mb-0"
        ></v-text-field>
        <v-card-actions v-if="!isRequestPostcode">
          <v-spacer />
          <v-btn
            type="submit"
            color="primary"
            :disabled="!valid"
            @click.stop="validatePostcode"
            :loading="loading"
            >Check Delivery Postcode</v-btn
          >
        </v-card-actions>
        <v-card-actions v-else>
          <v-spacer />
          <v-btn
            type="submit"
            color="primary"
            :disabled="!valid"
            @click.stop="showUserInfoDialog"
            >Request Postcode</v-btn
          >
        </v-card-actions>
      </v-form>
    </v-card>
    <v-dialog v-model="messageDialog" max-width="500px">
      <v-card class="pa-3" flat>
        <v-toolbar color="background" flat dense>
          <v-toolbar-title class="subtite-2 font-weight-medium">{{
            messageTitle
          }}</v-toolbar-title>
          <v-spacer />
          <v-btn icon @click="messageDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>{{ messageText }}</v-card-text>
        <v-card-actions v-if="enablePostcodeRequest">
          <v-btn
            outlined
            block
            color="blue darken-2"
            @click.stop="showUserInfoDialog"
            >Request Your PostCode</v-btn
          >
        </v-card-actions>
        <v-card-actions>
          <v-btn
            v-if="allowAnonUsers"
            text
            color="blue darken-2"
            :loading="loading"
            @click.stop="signInGuest"
            >Browse Store</v-btn
          >
          <v-spacer />
          <v-btn
            v-if="!isRegistrationPage"
            class="white--text"
            color="blue darken-2"
            :to="{ name: 'Registration' }"
            >Sign up</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="userInfoDialog" max-width="500px">
      <v-card class="pa-3" flat>
        <v-form v-model="valid" ref="detailsForm" @submit.prevent>
          <v-toolbar color="background" flat dense>
            <v-toolbar-title class="subtite-2 font-weight-medium"
              >Your Details</v-toolbar-title
            >
            <v-spacer />
            <v-btn icon @click="userInfoDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>

          <v-card-text>{{ yourDetailsText }}</v-card-text>
          <v-text-field
            v-model="name"
            outlined
            prepend-inner-icon="person"
            :rules="[required('Name ')]"
            label="Your Name"
            class="pa-2 pb-0 mb-0"
          ></v-text-field>
          <v-text-field
            v-model="email"
            outlined
            prepend-inner-icon="email"
            :rules="[required('Email'), isEmail]"
            label="Your Email"
            class="pa-2 pb-0 mb-0"
          ></v-text-field>
          <v-card-actions>
            <v-btn
              type="submit"
              block
              color="primary"
              large
              :disabled="!valid"
              :loading="loading"
              @click.stop="submitRequest"
              >Submit Request</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import checkPostCode from "@/util/validation/postcode.js";
import checkEmail from "@/util/validation/email.js";
import { mapActions } from "vuex";
export default {
  name: "PostcodeRequestForm",
  props: {
    isRequestPostcode: {
      type: Boolean,
      required: true,
    },
    descriptionText: {
      type: String,
      required: true,
    },
    isRegistrationPage: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data: () => {
    return {
      valid: false,
      postcode: "",
      name: "",
      email: "",
      required(fieldName) {
        return (v) => (v && v.length > 0) || `${fieldName} Required`;
      },
      isPostCode: (val) => {
        return checkPostCode(val);
      },
      isEmail: (val) => {
        return checkEmail(val);
      },
      messageTitle: "",
      messageText: "",
      messageDialog: false,
      userInfoDialog: false,
      yourDetailsText:
        "Please provide us your details so that we can let you know once your postcode is added to our delivery area",

      enablePostcodeRequest: false,
      loading: false,
    };
  },
  methods: {
    ...mapActions([
      "checkDeliveryPostcode",
      "sendPostcodeRequest",
      "setSnackbar",
      "authUser",
      "setGuestUser",
      "getCustomer",
      "setGuestTrolly",
    ]),

    validatePostcode() {
      this.loading = true;
      const params = Object.assign({
        identity: "nws9987",
        postcode: this.postcode,
      });

      this.checkDeliveryPostcode(params)
        .then((response) => {
          console.log("-- Check Response");
          console.log(response);

          if (response) {
            if (response.success) {
              //this.$emit("validated", this.postcode);
              if (this.isCncOnly) {
                if (!this.isRegistrationPage) {
                  this.messageTitle = "CLICK & COLLECT ONLY";
                  this.messageText =
                    "Sorry We dont deliver to your area, continue shopping or request your postcode to be added";
                  //    this.enableContinueShopping = true
                  this.messageDialog = true;
                  this.enablePostcodeRequest = true;
                } else {
                  this.$emit("validated", this.postcode);
                }
              } else {
                //    this.enableContinueShopping = true
                if (!this.isRegistrationPage) {
                  this.enablePostcodeRequest = false;
                  this.messageTitle = "GREAT, WE DELIVER TO YOUR AREA!";
                  this.messageText =
                    "To start shopping just Sign in or Sign up if you are not already registered";
                  this.messageDialog = true;
                } else {
                  this.$emit("validated", this.postcode);
                }
              }
            } else {
              //this.$emit("not-validated", this.postcode);
              this.messageTitle = "SORRY, WE DO NOT DELIVER TO YOUR AREA";
              this.enablePostcodeRequest = true;
              this.messageText =
                "You are more then welcome to continue browsing our store";
              this.messageDialog = true;
            }
          }
        })
        .catch((msg) => {
          this.messageTitle = "SORRY, WE DO NOT DELIVER TO YOUR AREA";
          this.enablePostcodeRequest = true;
          this.messageText =
            "You are more then welcome to continue browsing our store";
          this.messageDialog = true;
        });
      this.loading = false;
    },
    async submitRequest() {
      //make api request with name postcode and email params
      //set user info dialog to false
      this.loading = true;
      console.log(
        "Submitting request for " +
          this.postcode +
          " from " +
          this.email +
          " " +
          this.name
      );
      let payload = {
        identity: "nws9987",
        email: this.email,
        name: this.name,
        postcode: this.postcode,
      };

      let response = await this.sendPostcodeRequest(payload);
      if (response.success == true) {
        this.setSnackbar({ text: "Postcode Request Sent Successfully" });
        this.userInfoDialog = false;
        this.messageDialog = false;
        this.$router.go(-1);
      } else {
        this.setSnackbar({ color: "error", text: response.message });
      }
      this.loading = false;
    },
    showUserInfoDialog() {
      this.userInfoDialog = true;
    },

    async signInGuest() {
      this.loading = true;

      let payload = {
        identity: "nws9987",
        email_addr: "demo@nationwilcox.co.uk",
        password: "pass",
      };

      let response = await this.authUser(payload);

      console.log("Response");
      console.log(response);

      if (response.success) {
        this.setGuestUser(true);

        let customerResponse = await this.getCustomer();
        console.log("-- Customer Response");
        console.log(customerResponse);

        //
        if (customerResponse.success) {
          if (customerResponse.allAvailableDays.length > 0) {
            //Use the last available date as our order date
            let payload = {
              trolly: [],
            };

            let guestTrolly = {
              id: 0,
              trolly_items: {},
              order_date:
                customerResponse.allAvailableDays[
                  customerResponse.allAvailableDays.length - 1
                ],
            };

            payload.trolly.push(guestTrolly);

            console.log("-- Setting Guest Trolly");
            console.log(payload);

            await this.setGuestTrolly(payload);
            this.$router.push({ name: "OrdersSearch" });
          } else {
            //No Days available for the guest user to order on
            this.setSnackbar({
              color: "error",
              text: "There are currently no valid order days enabled for this customer",
            });
          }
        } else {
          //get-customer failed
          this.setSnackbar({
            color: "error",
            text: "Error retrieving customer details",
          });
        }
      } else {
        //auth-user failed
        this.setSnackbar({
          color: "error",
          text: "Unable to sign in as guest user, it may not be configured correctly",
        });
      }
      this.messageDialog = false;

      this.loading = false;
    },
  },
  computed: {
    allowAnonUsers() {
      return this.$store.getters.retrieveAllowAnonUsers;
    },

    isWelcomePage() {
      return this.$route.name == "Welcome";
    },
    isCncOnly() {
      return this.$store.state.user.cncOnly == "1";
    },
  },
  activated() {
    this.postcode = "";
    this.email = "";
    this.name = "";
  },
};
</script>